import * as React from 'react';
import './forbiddenPage.css'
const forbiddenPage = (props: any) => {

    return (
        <div id={'forbidden-wrapper'} style={{backgroundColor: '#2D3436', height: '100%'}}>
            <header style={{height: 50, display: "flex"}} className="bo-core-header top-header">
                <div style={{
                    float: "left",
                    paddingLeft: 4,
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                }}>
                </div>
            </header>
            <div className="forbidden-container">
                <div id={'forbidden'}>
                    <div className={'forbidden'}>
                        <div className="forbidden-403">
                            <h1>403</h1>
                        </div>
                        <h2>Forbidden</h2>
                        <p>We are sorry, but you do not have access to this page.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default forbiddenPage;




// WEBPACK FOOTER //
// ./app/views/bo-core/forbidden/ForbiddenPage.tsx